/**
 * Fields of a phase edit safe to patch onto the cached bean. Whitelisted
 * (instead of spreading the whole payload) so a partial payload can never
 * clobber server-owned aggregates living on the same bean (`progressStatus`,
 * `totalTaskCount`, `entityOrder`). Mirrors the whitelist that used to live in
 * `collections/plan-board/actions.ts:applyPhasePatch` — deleted from there
 * once this collection lands.
 */ const PHASE_PATCH_FIELDS = [
    'projectPhaseName',
    'startDate',
    'dueDate',
    'phaseDescription',
    'private'
];
/**
 * Build the entity-shaped optimistic patch for a phase edit: whitelisted
 * scalars replace, and `fields[]` (custom-field edits, e.g. the header status
 * pill) merge by `fieldId` — a partial `fields` payload must never drop the
 * bean's other fields.
 */ export const buildPhaseOptimisticPatch = (original, payload)=>{
    var _payload_fields;
    const patch = {};
    PHASE_PATCH_FIELDS.forEach((field)=>{
        if (payload[field] !== undefined) {
            Object.assign(patch, {
                [field]: payload[field]
            });
        }
    });
    if ((_payload_fields = payload.fields) === null || _payload_fields === void 0 ? void 0 : _payload_fields.length) {
        var _original_fields;
        const existing = (_original_fields = original.fields) !== null && _original_fields !== void 0 ? _original_fields : [];
        const patchById = new Map(payload.fields.map((f)=>[
                f.fieldId,
                f
            ]));
        patch.fields = [
            ...existing.map((f)=>patchById.has(f.fieldId) ? {
                    ...f,
                    ...patchById.get(f.fieldId)
                } : f),
            ...payload.fields.filter((f)=>!existing.some((e)=>e.fieldId === f.fieldId))
        ];
    }
    return patch;
};
/** Does this payload carry any field `buildPhaseOptimisticPatch` would apply? */ export const hasPhasePatchContent = (payload)=>{
    var _payload_fields;
    return Boolean((_payload_fields = payload.fields) === null || _payload_fields === void 0 ? void 0 : _payload_fields.length) || PHASE_PATCH_FIELDS.some((field)=>payload[field] !== undefined);
};
/** Would applying this payload change anything the bean doesn't already hold? */ export const isPhasePatchNoop = (phase, payload)=>{
    var _payload_fields;
    const scalarsEqual = PHASE_PATCH_FIELDS.every((field)=>payload[field] === undefined || payload[field] === phase[field]);
    if (!scalarsEqual) {
        return false;
    }
    return ((_payload_fields = payload.fields) !== null && _payload_fields !== void 0 ? _payload_fields : []).every((patchField)=>{
        var _phase_fields;
        const existing = ((_phase_fields = phase.fields) !== null && _phase_fields !== void 0 ? _phase_fields : []).find((field)=>field.fieldId === patchField.fieldId);
        return existing != null && existing.fieldValue === patchField.fieldValue;
    });
};
